import React, { FC, ReactElement, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Typography } from "@material-ui/core";

import { useChangePhoneStyles } from "./ChangePhoneStyles";
import { ChangeInfoTextField } from "../../../ChangeInfoTextField/ChangeInfoTextField";
import ChangePhoneModal from "./ChangePhoneModal/ChangePhoneModal";
import {
  selectUserIsLoaded,
    selectUserProfilePhoneCode,
    selectUserProfilePhoneNumber
} from "../../../../../store/ducks/user/selectors";
import { setUserLoadingStatus } from "../../../../../store/ducks/user/actionCreators";
import { withDocumentTitle } from "../../../../../hoc/withDocumentTitle";
import { LoadingStatus } from "../../../../../types/common";
import { useModalWindow } from "../../../../../hook/useModalWindow";

const ChangePhone: FC = (): ReactElement => {
    const classes = useChangePhoneStyles();
    const dispatch = useDispatch();
    const phoneCode = useSelector(selectUserProfilePhoneCode);
    const phoneNumber = useSelector(selectUserProfilePhoneNumber);
    const isUpdatedSuccess = useSelector(selectUserIsLoaded);
    const { visibleModalWindow, onOpenModalWindow, onCloseModalWindow } = useModalWindow();
    const isPhoneNumberValid = phoneCode && phoneNumber ? true : false;

    useEffect(() => {
        console.log("isUpdatedSuccess", isUpdatedSuccess);
        onCloseModalWindow();
        dispatch(setUserLoadingStatus(LoadingStatus.NEVER));
    }, [isUpdatedSuccess]);

    return (
        <>
          {isPhoneNumberValid && (
            <>
              <div className={classes.textFieldWrapper}>
                <ChangeInfoTextField
                  label="Current"
                  type="text"
                  variant="filled"
                  value={`${phoneCode}${phoneNumber}`}
                  fullWidth
                  disabled />
              </div>
              <Divider />
            </>)}
            <div
                id={"openChangePhoneModal"}
                className={classes.updatePhoneNumber}
                onClick={onOpenModalWindow}
            >
                <Typography variant={"body1"} component={"span"}>
                    {`${isPhoneNumberValid ? 'Update' : 'Add'} phone number`}
                </Typography>
            </div>
            {/* {isPhoneNumberValid && (
              <div className={classes.deletePhoneNumber}>
                <Typography variant={"body1"} component={"span"}>
                    Delete phone number
                </Typography>
              </div>
            )} */}
            <ChangePhoneModal visible={visibleModalWindow} onClose={onCloseModalWindow} isPhoneNumberValid={isPhoneNumberValid} />
        </>
    );
};

export default withDocumentTitle(ChangePhone)("Change phone");
